import * as React from "react";
import { useNavigate } from "react-router-dom";
import Page from "app/components/Page";

import { useAppState } from "app/providers/AppStateProvider";
import SummaryView from "./components/SummaryView";
import VerifyOtp from "./components/VerifyOtp";
import Completed from "app/components/Payment/Completed";
import tw from "twin.macro";
import WaitingView from "./components/WaitingView";

type activeViewType = "confirm" | "verify" | "waiting" | "completed";

export default function BushaTransferConfirm() {
  const navigate = useNavigate();
  const { mode } = useAppState();
  const [activeView, setActiveView] = React.useState<activeViewType>("confirm");

  const isLive = mode === "live";

  const canGoBack = ["confirm", "verify"].includes(activeView)

  return (
    <Page
      onBack={!canGoBack ? undefined : activeView !== "confirm" ? () => setActiveView("confirm") : () => navigate(-1)}
    >
      <div tw="flex flex-col h-full">
        {canGoBack &&
          (<div tw="flex items-center gap-[10px] mb-[24px]">
            <div tw="grow">
            <h4 css={tw`headline-medium`}>Confirm payment</h4>
          </div>
          </div>
          )}
        {isLive && (
          <>
            {activeView === "confirm" && (
              <SummaryView onDone={(options) => setActiveView(options?.skipVerify ? "waiting" : "verify")} />
            )}

            {activeView === "verify" && (
              <VerifyOtp onDone={() => setActiveView("waiting")} />
            )}

            {activeView === "waiting" && <WaitingView onDone={() => setActiveView("completed")} />}

            {activeView === "completed" && <Completed />}
          </>
        )}
      </div>
    </Page>
  );
}
